import { ionicBootstrap, Platform } from 'ionic-angular';
import { StatusBar } from 'ionic-native';
import { Component } from '@angular/core';
//import { Routes } from '@angular/router';
import { HomePage } from './pages/home/home';
import { MoreModal } from './pages/more/more';
import { ProjectPage } from './pages/project/project';

@Component({
  template: '<ion-nav [root]="rootPage"></ion-nav>'
})
/*@Routes([
  { path: '/itineraire', component: ItineraryPage },
  { path: '/itineraire/:start/:end', component: ItineraryPage },
  { path: '/les-lignes', component: SchedulesPage },
  { path: '/les-lignes/:line/:direction/:stop', component: SchedulesPage }
])*/
export class App {
  rootPage: any = HomePage;

  constructor(platform: Platform) {
    platform.ready().then(() => {
      StatusBar.styleDefault();
    });
  }
}

// Bootstraping
ionicBootstrap(App, [], {
  mode: 'md',
  monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  platforms: {
    ios: {
      backButtonText: 'Retour',
      statusbarPadding: false
    }
  }
})
